// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"e6d87cac","93":"2feb6b9f","170":"654be05e","267":"13da5c3a","323":"23b2eefb","335":"d4ff8978","368":"dd8b39fe","404":"573c3e7f","856":"7fc8915e"}[chunkId] + ".chunk.css";
};